module.exports = __webpack_public_path__ + "static/insta-46a4e403716cd8d08ab073216ce4df47.png";